
<template>
  <vs-popup
    :title="chartTitle"
    :active.sync="isActive"
    id="monitoring-engine-expanded-chart"
    :class="{ 'error-expanded-chart': isHoveringError }"
  >
    <div class="sub-header">
      <div
        class="
          time-range-text-wrapper
          flex flex-no-wrap flex-shrink-0
          items-center
          mr-auto
        "
      >
        <div
          class="
            time-range-text
            flex flex-no-wrap flex-shrink-0
            items-center
            gap-3
          "
        >
          <span
            class="material-icons-outlined calendar-icon pointer-events-none"
            :style="{ 'font-size': '15px' }"
          >
            calendar_month
          </span>
          <span class="aisea-text-14-300-black flex-shrink-0">
            {{ displayTimeFromTo }}
          </span>
        </div>
      </div>
      <div class="btns">
        <div
          class="add-text-btn-wrapper"
          :class="{
            disabled: isAddTextModeDisabled,
          }"
          @click="handleClickAddTextBtn"
        >
          <span
            class="material-icons add-text-btn cursor-pointer text-center"
            :class="{
              disabled: isAddTextModeDisabled,
              active: !isAddTextModeDisabled && isAddTextMode,
            }"
            :disabled="isAddTextModeDisabled"
            :style="{ width: '40px' }"
          >
            add
          </span>
        </div>
        <vs-dropdown
          vs-trigger-click
          class="more-button cursor-pointer"
          color="#2D9CDB"
          :style="{ width: '40px' }"
        >
          <svg
            class="more-horizontal-btn cursor-pointer"
            width="13"
            height="24"
            viewBox="0 0 13 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="1.5"
              cy="1.5"
              r="1.5"
              transform="rotate(-90 1.5 1.5)"
              fill="none"
            />
            <circle
              cx="6.5"
              cy="1.5"
              r="1.5"
              transform="rotate(-90 6.5 1.5)"
              fill="none"
            />
            <circle
              cx="11.5"
              cy="1.5"
              r="1.5"
              transform="rotate(-90 11.5 1.5)"
              fill="none"
            />
          </svg>
          <vs-dropdown-menu
            class="more-horizontal-btn-dropdown more-horizontal-dropdown"
            vs-trigger-click
          >
            <vs-dropdown-item
              @click="
                selectedChannelOriginId !== 'custom'
                  ? handleClickAddCustomReportBtn(channelDataRecord)
                  : handleClickRemoveCustomBtn(channelDataRecord)
              "
              class="add-custom-report-btn m-0"
            >
              <span class="flex justify-between items-center">
                <span class="material-icons-outlined">
                  {{ selectedChannelOriginId !== "custom" ? "add" : "delete" }}
                </span>
                <span>{{
                  selectedChannelOriginId !== "custom"
                    ? "カスタムレポートに追加"
                    : "カスタムレポートから削除"
                }}</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
    <div id="expanded-chart-container"></div>
    <div id="expanded-chart-hover-text" ref="expandedChartHoverText">
      <ul class="hover-dropdown--menu vs-dropdown--menu">
        <li
          class="vs-component vs-dropdown--item add-custom-report-btn"
          style=""
        >
          <a
            class="vs-dropdown--item-link"
            @click.stop.prevent="
              !isCurrentSelectedAdded
                ? handleClickAddPoint()
                : handleClickRemovePoint()
            "
          >
            <span class="flex justify-between add-message items-center">
              <span class="material-icons-outlined">
                {{ !isCurrentSelectedAdded ? "add" : "delete" }}
              </span>
              <span>{{
                !isCurrentSelectedAdded
                  ? "ポインターを追加"
                  : "ポインターを削除"
              }}</span>
            </span>
          </a>
        </li>
      </ul>
    </div>
    <a
      id="expand-prev-chart-btn"
      class="btn expand-prev-chart cursor-pointer"
      @click.stop.prevent="handleClickExpandPrevBtn"
      ><span class="material-icons arror-icon"> arrow_back_ios </span></a
    >
    <a
      id="expand-next-chart-btn"
      class="btn expand-next-chart cursor-pointer"
      @click.stop.prevent="handleClickExpandNextBtn"
      ><span class="material-icons arror-icon"> arrow_forward_ios </span></a
    >
  </vs-popup>
</template>

<script>
import Highcharts from "highcharts/highstock";
import moment from "moment";
import { ColorMixin } from "@/mixins";
const MAX_SELECT_POINT_LENGTH = 3;

export default {
  name: "engineDetailExpandedChart",
  props: {
    popupActive: { type: Boolean, default: false },
    expandedChartData: { type: Array, default: () => [] },
    channelDataRecord: { type: Object },
    channelTimeFrom: { type: String },
    channelTimeTo: { type: String },
    selectedChannelOriginId: { type: [Number, String] },
    handleClickAddCustomReportBtn: { type: Function },
    removeCustomChannelId: { type: Function },
    xAxisStartValue: { type: Number },
    xAxisEndValue: { type: Number },
  },
  components: {},
  mixins: [ColorMixin],
  data() {
    return {
      isActive: false,
      isAddTextMode: false,
      selectedTextPoints: {},
      currentSelectedPoint: null,
      stockChart: null,
      isHoveringError: false,
    };
  },
  computed: {
    channelId() {
      if (!this.channelDataRecord) return "";
      if (!this.channelDataRecord.channel_id) return "";
      return `${this.channelDataRecord.channel_id}`;
    },
    channelName() {
      if (!this.channelDataRecord) return "";
      if (!this.channelDataRecord.channel_name) return "";
      return `${this.channelDataRecord.channel_name}`;
    },
    chartTitle() {
      if (!this.channelId) return "";
      if (!this.channelName) return "";
      return `${this.channelId} ${this.channelName}`;
    },
    displayTimeFrom() {
      if (typeof this.channelTimeFrom != "string") return;
      if (this.channelTimeFrom.length <= 0) return;
      return moment(this.channelTimeFrom).local().format("YYYY/MM/DD HH:mm");
    },
    displayTimeTo() {
      if (typeof this.channelTimeTo != "string") return;
      if (this.channelTimeTo.length <= 0) return;
      return moment(this.channelTimeTo).local().format("YYYY/MM/DD HH:mm");
    },
    displayTimeFromTo() {
      if (!this.displayTimeFrom) return "";
      if (!this.displayTimeTo) return "";
      return `${this.displayTimeFrom} - ${this.displayTimeTo}`;
    },
    isAddTextModeDisabled() {
      return (
        MAX_SELECT_POINT_LENGTH <= Object.keys(this.selectedTextPoints).length
      );
    },
    isCurrentSelectedAdded() {
      if (!this.currentSelectedPoint) return false;
      return Object.prototype.hasOwnProperty.call(
        this.selectedTextPoints,
        this.currentSelectedPoint.x,
      );
    },
    displayUnit() {
      if (!this.channelDataRecord) return "";
      if (!this.channelDataRecord.display_unit) return "";
      return this.channelDataRecord.display_unit;
    },
    isGantt() {
      if (!this.channelDataRecord) return false;
      return !this.channelDataRecord.value_number_range;
    },
    categories() {
      if (!this.channelDataRecord) return [];
      if (!this.channelDataRecord.value_string_options) return [];
      return this.channelDataRecord.value_string_options.split("/");
    },
  },
  watch: {
    popupActive(val) {
      this.isActive = val;
    },
    isActive(val) {
      if (val) return;
      // close時
      this.teardown();
      this.$emit("closePopup");
    },
    expandedChartData() {
      this.$nextTick(() => {
        this.stockChart = this.createStockChart();
      });
    },
  },
  methods: {
    setup() {
      this.resetSelectedPoints();
      this.isAddTextMode = false;
      this.hideHoverText();
    },
    teardown() {
      this.isAddTextMode = false;
      this.hideHoverText();
      this.selectedTextPoints = {};
      this.resetCurrentSelectedPoint();
      this.stockChart = this.createStockChart();
    },
    createStockChart(data) {
      const self = this;
      Highcharts.setOptions({
        global: { useUTC: false },
        lang: {
          months: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
          shortMonths: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
          weekdays: ["日", "月", "火", "水", "木", "金", "土"],
          thousandsSep: ",",
        },
      });
      const stockChart = Highcharts.stockChart("expanded-chart-container", {
        rangeSelector: {
          enabled: false,
        },
        title: {},
        chart: {
          events: {
            click: function () {
              self.hideHoverText();
            },
          },
        },
        plotOptions: {
          flags: {},
          series: {
            cursor: "pointer",
            point: {
              events: {
                redraw() {},
                click: function (e) {
                  self.setCurrentSelectedPoint(e.point);
                  const expandedChartHoverText =
                    self.$refs.expandedChartHoverText;
                  expandedChartHoverText.style.setProperty(
                    "--text-display",
                    `none`,
                  );
                  if (!(self.isCurrentSelectedAdded || self.isAddTextMode))
                    return;
                  console.log(e);

                  const nextTop = e.chartY + 100;
                  const nextLeft = e.chartX - 100;
                  expandedChartHoverText.style.setProperty(
                    "--text-bottom",
                    `${e.chartY}px`,
                  );
                  expandedChartHoverText.style.setProperty(
                    "--text-top",
                    `${nextTop}px`,
                  );
                  expandedChartHoverText.style.setProperty(
                    "--text-left",
                    `${nextLeft}px`,
                  );
                  expandedChartHoverText.style.setProperty(
                    "--text-display",
                    `block`,
                  );
                },
                mouseOver: (e) => {
                  self.isHoveringError = e.target && e.target.error;
                },
                mouseOut: () => {
                  self.isHoveringError = false;
                },
              },
            },
            turboThreshold: 0,
          },
        },

        xAxis: {
          type: "datetime",
          min: this.xAxisStartValue,
          max: this.xAxisEndValue,
          labels: {},
          dateTimeLabelFormats: {
            day: "%m/%d",
            week: "%m/%d",
            month: "%Y/%m",
            year: "%Y",
          },
        },
        yAxis: this.isGantt
          ? {
              labels: {
                format: `{text} ${this.displayUnit}`,
              },
              // ステータスの時
              ...{ categories: this.categories },
            }
          : {
              labels: {
                format: `{text} ${this.displayUnit}`,
              },
            },
        navigator: {
          // navigator:https://stackoverflow.com/questions/15717835/change-navigator-date-format-in-highstock
          xAxis: {
            type: "datetime",
            min: this.xAxisStartValue,
            max: this.xAxisEndValue,
            dateTimeLabelFormats: {
              day: "%Y/%m/%d",
              week: "%Y/%m/%d",
              month: "%Y/%m/%d",
              year: "%Y/%m",
            },
          },
        },

        series: [
          {
            type: "line",
            crisp: false,
            name: "expandedChartData",
            id: "expandedChartData",
            data: data || this.expandedChartData,
            tooltip: {},
          },
          {
            id: "flags",
            type: "flags",
            data: [],
            allowOverlapX: true, // 重複許容
            shape: "squarepin",
            // color: "#2D9CDB", // ここじゃ効かないのでcssの方で適用する
            style: {},
            borderRadius: 100,
            states: {
              hover: {},
            },
            events: {},
            onSeries: "expandedChartData",
            tooltip: {
              xDateFormat: "%Y/%m/%d %H:%M",
            },
          },
        ],
        credits: {
          enabled: false,
        },
        tooltip: {
          formatter: function () {
            // flagにホバーした場合
            if (this.point) {
              return [
                "<b>" + moment(this.x).format("YYYY/MM/DD HH:mm") + "</b>",
              ];
            }
            // 線にホバーした場合
            return [
              "<b>" + moment(this.x).format("YYYY/MM/DD HH:mm") + "</b>",
              self.getYValueDisp(this.y),
            ];
          },
          /**
           * 時間標記:https://api.highcharts.com/highstock/xAxis.dateTimeLabelFormats
           * 曜日標記：https://api.highcharts.com/highcharts/tooltip.dateTimeLabelFormats
           */
          xDateFormat: "%Y/%m/%d %H:%M",
          pointFormat: "<b>{point.y}</b>",
          shape: "callout",
        },
      });
      return stockChart;
    },
    handleClickAddPoint() {
      if (this.isAddTextModeDisabled) return;
      if (!this.isAddTextMode) return;
      if (!this.stockChart) return;
      this.hideHoverText();
      this.setSelectedPoints(
        this.currentSelectedPoint.index,
        this.currentSelectedPoint,
      );
      this.resetCurrentSelectedPoint();
      this.isAddTextMode = false;
    },
    handleClickRemovePoint() {
      this.hideHoverText();
      const currentSelectedPointX = this.currentSelectedPoint.x;
      this.stockChart.series[1].data
        .find((d) => d.name === `flagOf${currentSelectedPointX}`)
        .remove();
      this.deleteSelectedPoints(
        currentSelectedPointX,
        this.currentSelectedPoint,
      );
      this.resetCurrentSelectedPoint();
    },
    resetSelectedPoints() {
      this.selectedTextPoints = {};
    },
    setSelectedPoints(id, point) {
      this.selectedTextPoints = {
        ...this.selectedTextPoints,
        [point.x]: point,
      };
      const toBeAdded = {
        x: point.x,
        index: point.index,
        title: `<span>${this.getYValueDisp(point.y)}</span><br>`,
        // NOTE: 時間確認用の記述
        // `<span>${moment(point.x)
        //   .local()
        //   .format("YYYY/MM/DD HH:mm:ss")}</span><br>` +
        // `<span>${moment(
        //   this.expandedChartData.find((cd, i) => i === point.index).x,
        // )
        //   .local()
        //   .format("YYYY/MM/DD HH:mm:ss")}</span><br>`,
        text: "Some event with a description",
        name: `flagOf${point.x}`,
      };
      this.stockChart.series[1].addPoint(toBeAdded);
    },
    deleteSelectedPoints(id) {
      this.stockChart.xAxis[0].removePlotLine(`plot-line-${id}`);
      this.$delete(this.selectedTextPoints, `${id}`);
    },
    setCurrentSelectedPoint(point) {
      this.currentSelectedPoint = point;
    },
    resetCurrentSelectedPoint() {
      this.currentSelectedPoint = null;
    },
    handleClickAddTextBtn() {
      if (this.isAddTextModeDisabled) return;
      this.isAddTextMode = !this.isAddTextMode;
      this.hideHoverText();
    },
    handleClickExpandPrevBtn() {
      this.teardown();
      this.$emit("expandPrevChart");
    },
    handleClickExpandNextBtn() {
      this.teardown();
      this.$emit("expandNextChart");
    },
    handleClickRemoveCustomBtn(channelDataRecord) {
      this.removeCustomChannelId(channelDataRecord);
      this.$nextTick(() => {
        this.isActive = false;
      });
    },
    hideHoverText() {
      const expandedChartHoverText = this.$refs.expandedChartHoverText;
      expandedChartHoverText.style.setProperty("--text-display", `none`);
    },
    getYValueDisp(yValue) {
      if (this.isGantt) return this.categories[yValue];
      if (typeof yValue === "number") return yValue.toLocaleString();
      return yValue;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#monitoring-engine-expanded-chart {
  &.error-expanded-chart {
    .highcharts-halo {
      fill: #eb5757;
    }
  }
  .highcharts-root {
    font-family: $aisea-font-family !important;
  }
  .vs-popup {
    position: relative;
    width: 100%;
    max-width: 980px;
    height: 520px;
    margin-left: 100px;
    margin-right: 100px;
    .vs-popup--header {
      font-family: $aisea-font-family;
    }
    .vs-popup--content {
      padding: 10px 30px 30px 30px;
      .sub-header {
        display: flex;
        justify-content: space-between;
        .time-range-text-wrapper {
          .time-range-text {
            margin-top: 0.4rem;
            margin-bottom: 0.4rem;
            background: #f2f2f2;
            border-radius: 20px;
            padding: 2px 12px;
            width: fit-content;
          }
        }
        .btns {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          max-width: 94px;
          width: 100%;
          .add-text-btn-wrapper,
          .more-button {
            width: 40px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover:not(.disabled) {
              background: #f8f8f8;
            }
          }
          .add-text-btn,
          .vs-con-dropdown.parent-dropdown.more-button,
          .more-horizontal-btn {
            > path,
            circle {
              fill: #4f4f4f;
            }
            > mask {
              fill-opacity: 1;
            }

            &.active {
              color: #2d9cdb;
              > path,
              circle {
                fill: #2d9cdb;
              }
            }
            &.disabled {
              cursor: default;
              color: rgba(51, 51, 51, 0.3);
              > path,
              circle {
                fill-opacity: 0.3 !important;
                fill: rgba(51, 51, 51, 0.3);
              }
            }
          }
        }
      }
    }
  }
  #expanded-chart-hover-text {
    position: absolute;
    z-index: 53000;
    --text-bottom: 0px;
    --text-left: 0px;
    --text-display: none;
    display: var(--text-display);
    top: var(--text-top);
    left: var(--text-left);
    .hover-dropdown--menu {
      width: unset;
      height: unset;
      padding: 0;
      background: #fff;
      border-radius: 5px;
      -webkit-box-shadow: 0 5px 25px 0 rgb(0 0 0 / 10%);
      box-shadow: 0 5px 25px 0 rgb(0 0 0 / 10%);
      border: 1px solid rgba(0, 0, 0, 0.1);
      position: relative;
      margin: 0;
    }
    .add-custom-report-btn {
      width: 182px;
      height: 56px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      a {
        padding-left: 20px;
        padding-right: 20px;
        .add-message {
          transition: all 0.25s ease;
          transition-timing-function: cubic-bezier(1, 0.5, 0.8, 1);
        }
        .add-custom-report-img {
          path {
            transition: all 0.25s ease;
            transition-timing-function: cubic-bezier(1, 0.5, 0.8, 1);
          }
        }
      }
      &:hover {
        .add-message {
          color: $aisea-blue;
        }
        .add-custom-report-img,
        .add-message {
          color: $aisea-blue;
          path {
            fill: $aisea-blue;
          }
        }
      }
    }
  }
  .expand-prev-chart,
  .expand-next-chart {
    position: absolute;
    top: 50%;
    .arror-icon {
      font-size: 40px;
      font-weight: 400;
      color: $aisea-white;
    }
  }
  .expand-prev-chart {
    left: -60px;
  }
  .expand-next-chart {
    right: -70px;
  }

  .highcharts-flags-series .highcharts-point .highcharts-label-box {
    stroke: #2d9cdb; // flagの枠の色
  }
  .highcharts-series,
  .highcharts-point,
  .highcharts-markers,
  .highcharts-data-labels {
  }
  .highcharts-crosshair {
    stroke: $aisea-blue;
    stroke-width: 1px;
  }
  .highcharts-plot-line {
    fill: none;
    stroke: $aisea-blue;
    stroke-width: 1px;
  }
}
.con-vs-dropdown--menu.vs-dropdown-menu.more-horizontal-btn-dropdown.more-horizontal-dropdown {
  z-index: 53000;
  .vs-dropdown--menu {
    width: unset;
    height: unset;
    padding: 0;
  }
  .add-custom-report-btn {
    width: 224px;
    height: 56px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    a {
      padding-left: 20px;
      padding-right: 20px;
      .add-custom-report-img {
        path {
          transition: all 0.25s ease;
          transition-timing-function: cubic-bezier(1, 0.5, 0.8, 1);
        }
      }
    }
    &:hover {
      .add-custom-report-img {
        path {
          fill: $aisea-blue;
        }
      }
    }
  }
  .vs-dropdown--menu--after {
    width: 0px;
    height: 0px;
  }
}
</style>
